import ReactApexChart from 'react-apexcharts';
import { Warning } from '@phosphor-icons/react';
import { Tooltip } from 'antd';
import { Brokerages } from '../../components/Brokerages/intex';
import { CardGraphic, StrategyContainer } from './styles';
import { useActives } from '../../../../../hooks/useActives';
import { useStrategy } from '../../hooks/StrategyHooks';
import { useEffect, useState } from 'react';

export function Strategy() {
  // @ts-ignore
  const { percentage } = useActives();

  const {
    action,
    fiis,
    rendaFixa,
    stocks,
    etfs,
    reits,
    crypto,
    checkIfItIsBalanced,
  } = useStrategy();

  const [chartWidth, setChartWidth] = useState(() => {
    if (window.innerWidth > 1900) return 1400;
    if (window.innerWidth > 1800) return 1300;
    if (window.innerWidth > 1700) return 1150;
    if (window.innerWidth > 1600) return 1000;
    if (window.innerWidth > 1400) return 850;
    if (window.innerWidth > 1350) return 750;
    if (window.innerWidth > 1300) return 650;
    if (window.innerWidth > 1250) return 600;
    if (window.innerWidth > 1200) return 500;
    if (window.innerWidth <= 510) return window.innerWidth * 0.7;
    if (window.innerWidth <= 630) return window.innerWidth * 0.65;
    if (window.innerWidth <= 768) return window.innerWidth * 0.7;
    return window.innerWidth * 0.8 - 370;
  });

  useEffect(() => {
    const handleResize = () => {
      setChartWidth(
        window.innerWidth > 1900
          ? 1400
          : window.innerWidth > 1800
          ? 1300
          : window.innerWidth > 1700
          ? 1150
          : window.innerWidth > 1600
          ? 1000
          : window.innerWidth > 1400
          ? 850
          : window.innerWidth > 1350
          ? 750
          : window.innerWidth > 1300
          ? 650
          : window.innerWidth > 1250
          ? 600
          : window.innerWidth > 1200
          ? 500
          : window.innerWidth <= 510
          ? window.innerWidth * 0.5
          : window.innerWidth <= 630
          ? window.innerWidth * 0.6
          : window.innerWidth <= 768
          ? window.innerWidth * 0.7
          : window.innerWidth * 0.8 - 370
      );
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const compare = {
    series: [
      {
        name: 'Ideal',
        data: [
          Number(action?.toFixed(2) || 0),
          Number(fiis?.toFixed(2) || 0),
          Number(rendaFixa?.toFixed(2) || 0),
          Number(stocks?.toFixed(2) || 0),
          Number(etfs?.toFixed(2) || 0),
          Number(reits?.toFixed(2) || 0),
          Number(crypto?.toFixed(2) || 0),
        ],
      },
      {
        name: 'Atual',
        data: [
          Number(percentage?.action || 0),
          Number(percentage?.fii || 0),
          Number(percentage?.rendaFixa || 0),
          Number(percentage?.stocks || 0),
          Number(percentage?.etfs || 0),
          Number(percentage?.reits || 0),
          Number(percentage?.crypto || 0),
        ],
      },
    ],
    options: {
      labels: [
        'Ações',
        'FIIs',
        'Renda Fixa',
        'Stocks',
        'ETFs',
        'REITs',
        'Criptomoedas',
      ],

      chart: {
        type: 'bar',
        toolbar: {
          show: true,
        },
      },

      fill: {
        opacity: 1,
      },

      dataLabels: {
        style: {
          colors: ['#ECF0F3'],
          fontSize: '16px',
        },
        formatter: (val: number) => `${val}%`,
      },

      yaxis: {
        labels: {
          style: {
            colors: ['#EC6643'],
            fontSize: '16px',
          },
          formatter: (val: number) => `${val}%`,
        },
      },

      tooltip: {
        enabled: false,
        y: {
          formatter: (val: number) => `${val}%`,
        },
      },

      grid: {
        borderColor: '#111',
        strokeDashArray: 0,
      },

      colors: ['#303F4B', '#F8B700'],

      xaxis: {
        categories: [
          'Ações',
          'FIIs',
          'Renda Fixa',
          'Stocks',
          'ETFs',
          'REITs',
          'Criptomoedas',
        ],
        labels: {
          style: {
            colors: [
              '#253A4A',
              '#253A4A',
              '#253A4A',
              '#253A4A',
              '#253A4A',
              '#253A4A',
              '#253A4A',
            ],
            fontSize: '16px',
          },
        },
      },

      legend: {
        position: 'bottom',
        horizontalAlign: 'right',
        fontSize: '16px',
      },
    },
  };

  return (
    <StrategyContainer>
      {window.screen.width > 768 && <Brokerages />}

      <CardGraphic balanced={checkIfItIsBalanced}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <h2>Estratégia X Carteira</h2>

          {!checkIfItIsBalanced && (
            <Tooltip
              placement="bottom"
              title={
                <p style={{ margin: 0 }}>
                  Este gráfico demonstra a comparação entre sua estratégia e a
                  sua alocação de ativos, para adequação da sua carteira conforme
                  sua estratégia, efetue o balanceamento na aba de simulação de
                  aportes.
                </p>
              }
            >
              <Warning size={30} color="red" />
            </Tooltip>
          )}
        </div>

        <ReactApexChart
          // @ts-ignore
          options={compare.options}
          series={compare.series}
          type="bar"
          height={352}
          width={chartWidth}
        />
      </CardGraphic>
    </StrategyContainer>
  );
}